export const styles = {
  icon: {
    color: "events.lightBlack",
    width: "30px",
    height: "30px",
  },
  closeIcon: {
    color: "text.primary",
    cursor: "pointer",
  },
  activeIcon: {
    color: "blue.main",
  },
  container: {
    width: "360px",
    backgroundColor: "events.grayShade2",
    overflow: "hidden",
    borderRadius: "5px",
    boxShadow: "4px 4px 4px 0px #0C38911A",
  },
  embeddedContainer: {
    width: "360px",
    backgroundColor: "events.grayShade2",
    overflow: "hidden",
    borderRadius: "5px",
    boxShadow: "4px 4px 4px 0px #0C38911A",
  },
  desc: {
    maxHeight: "60px",
    minHeight: "60px",
    paddingLeft: "20px",
    paddingRight: "20px",
    display: "flex",
    boxSizing: "border-box",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid",
    borderColor: "events.grayShade1",
  },
  title: {
    color: "text.primary",
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "30px",
  },
  search: {
    padding: "20px 20px 15px",
  },
  clContainer: {
    maxHeight: "350px",
  },
  fixedHeightClContainer: {
    maxHeight: "350px",
    minHeight: "350px",
  },
  noMatch: {
    paddingTop: "40%",

    "& p": {
      textAlign: "center",
      fontWeight: "500",
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
  companyItem: {
    padding: "15px 20px 0px 15px",
    borderBottom: "1px solid",
    borderColor: "events.grayShade1",

    "&:focus, &:hover": {
      cursor: "pointer",
      backgroundColor: "events.blueShade2",
    },
  },
  item: {
    maxHeight: "55px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    justifyContent: "space-between",
    borderBottom: "1px solid",
    borderColor: "events.grayShade1",
  },
  info: {
    display: "flex",
    boxSizing: "border-box",
  },
  img: {
    maxWidth: "55px",
    borderRadius: "50%",
    marginTop: "2px",
    marginRight: "10px",
    marginBottom: "15px",
  },
  imgIcon: {
    maxWidth: "55px",
    borderRadius: "50%",
    marginTop: "2px",
    marginRight: "10px",
    marginBottom: "15px",
    border: "0px",
  },
  logo: {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    border: "1px solid",
    borderColor: "border.default",
  },
  name: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "19px",
    color: "text.primary",
  },
  role: {
    paddingTop: "5px",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "16px",
    color: "text.primary",
  },
};
